import { defineComponent as _defineComponent } from 'vue'
import { CostCode } from '@newmoon-org/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCostCodeListCard',
  props: {
  costCode: CostCode,
  selected: Boolean,
  selectionConfirmationFunction: {
    type: Function,
    default: async () => true,
  },
},
  emits: ['selection-changed'],
  setup(__props, { emit }) {

const props = __props





async function selectionChanged() {
  const result = await props.selectionConfirmationFunction(props.costCode, !props.selected);
  if (result) {
    emit('selection-changed', { id: props.costCode.id, isSelected: !props.selected });
  }
}

return { __sfc: true,emit, props, selectionChanged }
}

})